import React from 'react';
import { ChatWindow } from '../ChatWindow/ChatWindow';
import { DOCK_WINDOW_W } from './windowLayout';

/**
 * One conversation in the desktop dock.
 *
 * This used to be a free-floating, draggable, resizable window positioned with absolute
 * coordinates saved to localStorage. That model produced the same bug three times over:
 *
 *   - every window opened at IDENTICAL coordinates, so they sat on top of each other;
 *   - a stored position outlived the viewport it was saved in, stranding windows half
 *     off the right edge and below the fold, with no way to drag them back;
 *   - a window taller than the clamp assumed overflowed the bottom of the screen.
 *
 * Patching the arithmetic kept missing cases, so the coordinates are gone. Windows now
 * sit in a flex row anchored to the bottom-right, like every messenger that has solved
 * this: they cannot overlap each other, cannot leave the viewport, and need no
 * babysitting. The "enlarge" button still opens the full-page chat for anyone who wants
 * more room.
 *
 * The height is capped against the viewport in CSS, so a resized browser is handled by
 * the browser instead of by a resize listener that can lag behind it.
 */
const DesktopChatWindow = ({ chat, onClose, onMinimize, onFocus, zIndex, style, onStartCall }) => (
    <div
        className="flex flex-col rounded-2xl overflow-hidden bg-white border border-slate-200/80 shadow-2xl"
        style={{
            width: DOCK_WINDOW_W,
            height: 'min(540px, calc(100vh - 120px))',
            zIndex,
            ...style,
        }}
        onMouseDown={() => onFocus?.(chat.id)}
    >
        <div className="flex-1 flex flex-col min-h-0">
            <ChatWindow
                activeChat={chat}
                isFloating={true}
                onClose={onClose}
                onMinimize={onMinimize}
                onStartCall={(isVideo) => {
                    if (onStartCall) {
                        onStartCall(chat.targetUserId || chat.id, isVideo ? 'video' : 'voice');
                    }
                }}
            />
        </div>
    </div>
);

export default DesktopChatWindow;
